import * as Yup from 'yup';

import customerSchema from './customer';

const customerFormSchema = Yup.object({
  customer: customerSchema
});

export default customerFormSchema;
export type CustomerFormSchema = ReturnType<typeof customerFormSchema.cast>;
